import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    enabled: !!import.meta.env.VITE_SENTRY_DSN,

    // Performance monitoring — 20% of transactions
    tracesSampleRate: 0.2,

    // Filter common browser noise
    ignoreErrors: [
        "ResizeObserver loop",
        "Network Error",
        "Request aborted",
        "canceled",
    ],
});
